import axios from '@/axios'

const state = {
    invoicingFreeTextView: [],
};

const getters = {
    getInvoicingFreeTextView: (state) => state.invoicingFreeTextView,
};

const actions = {
    async loadInvoicingFreeTextView(context, data) {
        await axios().get(`/getInvoicingFreeTextView`, {
            params: {
                invoice_number: data.invoice_number,
                batch_type: data.batch_type,
                issue_tracker_num: data.issue_tracker_num,
                page: data.page,
                per_page: data.per_page,
                status: data.status
            }
        }).then(response => {
            if (response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            }
            context.commit('setInvoicingFreeTextView', response.data.invoicingFreeTextView)
        })
    },
    async deleteInvoicingFreeText(context, data) {
        await axios().post(`/deleteInvoicingFreeText`, {
            itemId: data.itemId
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async updateInvoicingFreeText(context, data) {
        await axios().post(`/updateInvoicingFreeText`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async addInvoicingFreeText(context, data) {
        await axios().post(`/addInvoicingFreeText`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
};

const mutations = {
    setInvoicingFreeTextView: (state, invoicingFreeTextView) => (state.invoicingFreeTextView = invoicingFreeTextView),
};

export default {
    state,
    getters,
    actions,
    mutations
}
